import { AutogenLayoutPortalSqlHDef } from "./autogen/AutogenLayoutPortalSqlHDef";
import {  ClickEvent } from "@mcleod/components";

export class PortalSqlHDef extends AutogenLayoutPortalSqlHDef {

    private timer: any;

    override onLoad() {
        clearInterval(this.timer);
        this.timer = setInterval(() => this.setid(), 200);
    }

  async setid() {
    clearInterval(this.timer);
    this.timer = null;
    if( this.textboxLgxshSqlgid.text == "" && this.sourceRenlgxsqlh.mode == "add" )
    {
        await this.sourceRenlgxsqlh2.search();
        const rows: any[] = this.sourceRenlgxsqlh2.data;
        let maxid = 0;
        for (const row of rows) {
            const fid = row._data.lgxsh_sqlgid;
            if( fid > maxid )
                maxid = fid;
        }
        maxid++;
        this.textboxLgxshSqlgid.text = maxid.toString();
    }
  }
}
